import { Component, OnInit } from '@angular/core';
import { Colleague_Interface } from 'src/app/Interface/Colleague_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ColleagueService } from 'src/app/Service/Colleague/Colleague.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ColleagueList',
  templateUrl: './ColleagueList.component.html',
  styleUrls: ['./ColleagueList.component.scss']
})
export class ColleagueListComponent implements OnInit {
  Procssing:boolean=false;


  StartSearchDate:string=""
  EndSearchDate:string=""
  SubmitPeriodDate:string="1"
  Filter_customer:String=''
  Filter_code:String=''
  page:number=0

  constructor(
    private Colleague_Service:ColleagueService,
    private Nav_Service:NavService,
    private Alerify:AlertifyService,
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(1147).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  DataList_Colleague:Array<Colleague_Interface>=[]
  ReadData_Colleague(StartSearchDate,EndSearchDate){
    this.Procssing=true

    this.StartSearchDate=StartSearchDate
    this.EndSearchDate=EndSearchDate
    this.Colleague_Service.GetRecord(
      StartSearchDate,
      EndSearchDate,
      this.Filter_customer,
      this.Filter_code,
      this.SubmitPeriodDate).subscribe(
      data=>{

        for(let item of data)
        {
          item.pdf = environment.BaseUrl + "ColleaguePrint/Print?id3=" + item.subjectId
            + "&id2=" + item.contractCustomerId
            + "&id=" + item.letterRequestCustomer
        }

        this.DataList_Colleague=data
        this.Procssing=false
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

}
